export const password = {
  passwordRequirementsText: "Password Requirements:",
  passwordInstruction: "Type in to confirm"
};
